import { Realtime, Event, TextMessage } from "leancloud-realtime";
import AV from "leancloud-storage";

const appId = "Buvisj4avtbPyrPKtXrxLtkc-gzGzoHsz";
let rootId: any = "5a430668d50eee0044cd1baa"; // 从后台获取
let appKey: any = "Allen OYang ";

import { newMessage, historyMessage, disposeMessage } from "pc@root/handle/message";

let NEWMESSAGE: any;
let CATHROOMMESSAGE: any;

export const newLeanCould = (roomid: string | null, name: string | null) => {
  appKey = name;
  rootId = roomid;

  AV.init({
    appId,
    appKey,
    serverURLs: "https://avoscloud.com"
  });

  const realtime = new Realtime({
    appId,
    appKey,
    server: {
      api: "avoscloud.com",
      RTMRouter: "router-g0-push.avoscloud.com"
    }
  });

  realtime
    .createIMClient(appKey)
    .then(result => {
      // 处理新消息
      NEWMESSAGE = result;
      getMessage();
      return result.getConversation(rootId);
    })
    .then(conversation => {
      // 处理历史消息
      CATHROOMMESSAGE = conversation;
      getHistory();
      return conversation.join();
    })
    .then(conversation => {
      console.log("加入成功", conversation.members);
    });
};

export const sendMessage = (msg: string) => {
  const message = new TextMessage(msg);
  message.setAttributes({
    notice: false,
    presenter: false
  });
  CATHROOMMESSAGE.send(message).then((resultMsg: any) => {
    disposeMessage(resultMsg);
  });
};

export const getMessage = () => {
  NEWMESSAGE.on(Event.MESSAGE, (message: any, conversation: any) => {
    newMessage(message);
  });
};

export const getHistory = () => {
  CATHROOMMESSAGE.queryMessages({
    limit: 20,
    type: TextMessage.TYPE
  })
    .then((messages: any) => {
      historyMessage(messages);
    })
    .catch(console.error.bind(console));
};



// WEBPACK FOOTER //
// ./src/pc/external/newIM.ts